<div class="elements-container" [ngClass]="chipType">
  <ion-chip class="element" [ngClass]="{ 'selected': selectedClass(element.id) }" (click)="selectElement(element.id)" *ngFor="let element of elements">
    {{ element?.name }}
  </ion-chip>
</div>
